var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsTabReportInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#505052",
    x: 10.4,
    y: 33.68,
    width: 17.4,
    height: 31.32,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#828284",
    x: 27.8,
    y: 7,
    width: 17.4,
    height: 58,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#AAAAAC",
    x: 45.2,
    y: 27.88,
    width: 17.4,
    height: 37.12,
    rx: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTabReportInactive);
export default __webpack_public_path__ + "static/media/icons_tab_report_inactive.9d58c6bd13790ed113a53604e21d3efe.svg";
export { ForwardRef as ReactComponent };